import { prepareWorkspaceCrypto } from '#sdk/workspace-client/prepare-ensure-sso-crypto';
// eslint-disable-next-line @typescript-eslint/naming-convention -- We want the naming to reflect the migration number
export class Migration_1_EnsureWorkspaceCrypto {
    adminCrypto;
    workspaceFetcher;
    constructor(adminCrypto, workspaceFetcher) {
        this.adminCrypto = adminCrypto;
        this.workspaceFetcher = workspaceFetcher;
    }
    async shouldExecute() {
        const adminMember = await this.adminCrypto.adminMember.get();
        const hasSsoCrypto = await this.adminCrypto
            .getSsoCrypto()
            .then(() => true)
            .catch(() => false);
        /**
         * If we have no ssoCrypto we need to do the migration
         * Also if the m001_workspaceKeyRequiredForInvitation is not set we do a dummy
         * migration in order to set it to true
         */
        return (!hasSsoCrypto ||
            adminMember.workspaceConfig
                ?.m001_workspaceKeyRequiredForInvitation !== true);
    }
    async execute() {
        const adminMember = await this.adminCrypto.adminMember.get();
        const workspaceCrypto = await prepareWorkspaceCrypto({
            workspaceId: adminMember.workspace.id,
            adminCrypto: this.adminCrypto,
        });
        await this.workspaceFetcher.post(['crypto-migration', 'workspace-crypto'], {
            body: workspaceCrypto.workspaceCryptoDto,
        });
    }
}
